// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3my9P","delete":"styles_delete__3w2GN","update":"styles_update__2OxYk","add":"styles_add__xjGxR"};